import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  constructor() {}

  createCallWindow() {
    return this.createWindow(window.location.origin + `/call`, false);
  }

  createMeetingCreateWindow(userIds: string[], groupIds: string[]) {
    let url = new URL(window.location.href);
    if (userIds.length) {
      let uids = userIds.join('-');
      url.searchParams.set('userId', uids);
    }

    if (groupIds) {
      let gids = groupIds.join('-');
      url.searchParams.set('groupId', gids);
    }

    url.searchParams.set('create', '1');
    url.pathname = '/meeting-room';
    return this.createWindow(url, false);
  }

  createMeetingWithIdWindow(id: string) {
    let url = new URL(window.location.href);
    url.pathname = `/meeting-room/${id}`;
    url.searchParams.set('popup', '1');
    return this.createWindow(url, false);
  }

  private createWindow(href: Parameters<typeof window.open>[0], cloneSessionStorage = false) {
    let currentSession = new Map(Object.entries(sessionStorage));
    if (!cloneSessionStorage) {
      sessionStorage.clear();
    }

    let result = window.open(href, '_blank');

    if (!cloneSessionStorage) {
      currentSession.forEach((v, k) => sessionStorage.setItem(k, v));
    }

    return result;
  }
}
